module.exports = __webpack_public_path__ + "img/S9011-IB.961c42b8.jpg";